<template>
	<div>
		<TableList 	:scroll="{x:2000}" :form_data_seo.sync="form_data_seo"  :columns="columns"
			:get_table_list="this.get_table_list" ref="list" 
			:submit_preprocessing="submit_preprocessing" :slot_table_list="['operation','operations','outcome_ids']"
			:rowKey="'id'">
			<template slot="operation" slot-scope="data">
				<a @click="approval(data.record)">{{data.record.status==0?'审核':'查看'}}</a>
			</template>
			<template slot="outcome_ids" slot-scope="data">
				<a @click="go_detail(data.record)">{{data.record.outcome_ids}}</a>
			</template>
		</TableList>

		<a-modal width="60%" @cancel='see_visible=false' :maskClosable='true' :footer='null' title="偏移地址更改"
			:visible="see_visible">
			<div class='info_item_box'>
				<p class='info_item'><span>状态：</span><span>{{see_info.status_name}}</span></p>
				<p class='info_item'><span>编号：</span><span>{{see_info.seller_id}}</span></p>
				<p class='info_item'><span>名称：</span><span>{{see_info.seller_name}}</span></p>
				<p class='info_item'><span>电话：</span><span>{{see_info.phone}}</span></p>
				<p class='info_item'><span>原地址：</span><span>{{see_info.old_address}}</span></p>
				<p class='info_item'><span>修正地址：</span><span>{{see_info.new_address}}</span></p>
				<p class='info_item'><span>提交司机：</span><span>{{see_info.chauffeur}}</span></p>
				<p class='info_item'><span>司机电话：</span><span>{{see_info.chauffeur_mobile}}</span></p>
				<p class='info_item'><span>关联出库单号：</span>
					<a @click="go_detail(see_info)">{{see_info.outcome_ids}}</a>
				</p>
			</div>
			<div v-if='see_info.status==0' style='width:95%;text-align: center;margin-top:16px;'>
				<a-button class="a_btn" type="danger" @click="operateAddressChangeFun(3)"
					style="margin-left: 30px;">拒绝</a-button>
				<a-button class="a_btn" type="primary" @click="operateAddressChangeFun(1)"
					style="margin-left: 30px;">同意</a-button>
			</div>
			<div v-else style='width:95%;text-align: center;margin-top:16px;'>
				<a-button class="a_btn" @click="see_visible=false" style="margin-left: 30px;">取消</a-button>
			</div>
		</a-modal>
	</div>
</template>

<script>
	// @ is an alias to /src
	import EditPop from "@/components/EditPop";
	import Form from "@/components/Form";
	import {
		getAddressChangeRecord,
		getStatusSelectChange,
		operateAddressChange
	} from "@/api/push";
	import TableList from "@/components/TableList";
	const columns = [{
			title: "ID",
			dataIndex: "id",
		}, {
			title: "分销商名称",
			dataIndex: "seller_name",
			width: 200,
		},
		{
			title: "分销商编号",
			dataIndex: "seller_id",
			width: 120,
		},
		
		{
			title: "原地址",
			dataIndex: "old_address",
			width: 300,
		},
		{
			title: "修正地址",
			dataIndex: "new_address",
			width: 300,
		},

	{
		title: "发起司机",
		dataIndex: "chauffeur",
	},
	
	{
		title: "司机电话",
		dataIndex: "chauffeur_mobile",
		width: 150,
	},
		{
			title: "关联出库单号",
			width: 150,
			scopedSlots: {
				customRender: "outcome_ids"
			},
		},
		{
			title: "状态",
			dataIndex: "status_name",
		},
		{
			title: "审核人",
			dataIndex: "operation_name",
		},
		{
			title: "发起时间",
			dataIndex: "create_time",
		},
		{
			title: "审核时间",
			dataIndex: "update_time",
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			},
			width: 80,
			fixed: 'right',
		}
	];



	export default {
		name: "send",
		components: {
			EditPop,
			Form,
			TableList
		},
		data() {
			return {
				see_info: {},
				see_visible: false,
				submit_preprocessing: {
					array_to_string: ['department']
				},
				get_table_list: getAddressChangeRecord,
				columns,
				visible: false,
				template_info: [],
				form_data_seo: {
					list: [{
							type: "text",
							name: "seller",
							title: "分销商信息",
							placeholder: '分销商信息',
							options: {},
						},
						{
							type: "text",
							name: "driver",
							title: "司机信息",
							mode: "default",
							options: {},
							list: []
						},
						{
							type: "text",
							name: "outcome_ids",
							title: "关联出库单",
							placeholder: "请输入关联出库单",
							options: {
								initialValue: ''
							}
						},
						{
							type: "select",
							name: "status",
							title: "状态",
							mode: "default",
							options: {},
							list: []
						},


						// {
						// 	type: "range_date",
						// 	name: "range_date",
						// 	title: "创建时间",
						// 	options: {
						// 		initialValue: [this.$moment(new Date(new Date().getTime() - (30 * 24 * 60 * 60 *
						// 			1000)), 'YYYY/MM/DD'), this.$moment(new Date(), 'YYYY/MM/DD')],
						// 	},
						// 	start: {
						// 		name: 'start_time'
						// 	},
						// 	end: {
						// 		name: 'end_time'
						// 	},
						// },
					],
					...this.$config.form_data_seo
				},
				form_data: {}
			};
		},
		async created() {
			this.get_select();
		},
		mounted() {
			// window.addEventListener('popstate', this.handleBackSendButton,false);
		},
		activated() {
			// this.$refs.send.get_list();
		},
		deactivated() {
			// this.$keep_route.remove(this.$options.name);
		},
		methods: {
			go_detail(e) {
				this.$keep_route.add(this.$options.name);
				this.$router.push({
					path: "/send/details",
					query: {
						id: e.delivery_id,
						seller_id: e.sub_seller_id ? e.sub_seller_id : ''
					}
				});
			},
			approval(data) {
				this.see_info = data
				this.see_visible = true

			},
			get_select() {
				getStatusSelectChange().then(res => {
					this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'status', 'list',
						res.data.list.map(it => {
							return {
								value: it.label,
								key: it.value
							}
						}))
				})

			},
			operateAddressChangeFun(type) {
				let that = this
				operateAddressChange({
					data: {
						id: this.see_info.id,
						status: type
					},
					info: true
				}).then(res => {
					this.$refs.list.get_list();
					this.see_visible = false
				})
			},
			report() {

			}
		}
	};
</script>

<style lang="less">
	@import url("../../../assets/less/app.less");

	.info_item_box {
		display: flex;
		flex-wrap: wrap;
		
		.info_item {
			width: 50%;
			margin-bottom: 12px;
		}

	}
</style>